export const CSS_DISPLAY_TAGS: Record<string, string> = {
  // hidden
  area: "none",
  base: "none",
  basefont: "none",
  datalist: "none",
  head: "none",
  link: "none",
  meta: "none",
  noembed: "none",
  noframes: "none",
  param: "block",
  rp: "none",
  title: "none",
  // block-like but need visibility
  script: "block",
  style: "block",
  // explicit inline
  template: "inline",
  // block
  address: "block",
  article: "block",
  aside: "block",
  blockquote: "block",
  body: "block",
  center: "block",
  dd: "block",
  details: "block",
  dialog: "block",
  dir: "block",
  div: "block",
  dl: "block",
  dt: "block",
  fieldset: "block",
  figcaption: "block",
  figure: "block",
  footer: "block",
  form: "block",
  h1: "block",
  h2: "block",
  h3: "block",
  h4: "block",
  h5: "block",
  h6: "block",
  header: "block",
  hgroup: "block",
  hr: "block",
  html: "block",
  legend: "block",
  li: "block",
  listing: "block",
  main: "block",
  marquee: "inline-block",
  menu: "block",
  nav: "block",
  ol: "block",
  optgroup: "block",
  option: "block",
  p: "block",
  plaintext: "block",
  pre: "block",
  search: "block",
  section: "block",
  source: "block",
  summary: "block",
  table: "table",
  track: "block",
  ul: "block",
  xmp: "block",
  // table
  caption: "table-caption",
  tr: "table-row",
  td: "table-cell",
  th: "table-cell",
  thead: "table-header-group",
  tbody: "table-row-group",
  tfoot: "table-footer-group",
  col: "table-column",
  colgroup: "table-column-group",
  // inline-block
  button: "inline-block",
  meter: "inline-block",
  progress: "inline-block",
  select: "inline-block",
  textarea: "inline-block",
  video: "inline-block",
  audio: "inline-block",
  object: "inline-block",
  // ruby
  ruby: "ruby",
  rt: "ruby-text",
  svg: "inline-block",
};

export const CSS_DISPLAY_DEFAULT = "inline";

export const CSS_WHITE_SPACE_TAGS: Record<string, string> = {
  listing: "pre",
  plaintext: "pre",
  pre: "pre",
  xmp: "pre",
  nobr: "nowrap",
  table: "initial",
  textarea: "pre-wrap",
  td: "normal",
  th: "normal",
};

export const CSS_WHITE_SPACE_DEFAULT = "normal";
